import { render } from "./ProjectsView.vue?vue&type=template&id=7119b839&scoped=true&ts=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"

import "./ProjectsView.vue?vue&type=style&index=0&id=7119b839&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7119b839"]])

export default __exports__